/**
 * PoiView
 *
 * Will make an AJAX call to the backend - through Varnish - to fetch the HTML
 * to render for a point of interest.
 *
 * @author Tim
 */
export default class PoiView {
    constructor($block) {
        this.$block = $block;
        this.$target = this.$block.querySelector('[data-poi-id]');

        this.fetch  = this.fetch.bind(this);
        this.render = this.render.bind(this);

        if (this.$target) {
            this.render();
        }
    }

    async render() {
        const result = await this.fetch();

        // If HTML was received to render, do so
        if (result?.html) {
            this.$block.innerHTML = result.html;
        }
        // If not, remove the block altogether. It serves no purpose.
        else {
            this.$block.remove();
        }
    }

    async fetch() {
        try {
            /**
             * @see AdPoiDetailController::getContent()
             */
            let url = placeholders.router.requestNoParams
                + '/block/'+ this.$block.dataset.blockId +'/ajax/get-content/'
                + this.$target.dataset.poiId
                + '/' + this.$target.dataset.poiFormat
                + '/' + this.$target.getBoundingClientRect().width
            ;

            const request = await fetch(
                url,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                }
            );

            return await request.json();
        } catch (e) {
            console.log(e);
        }
    }
}
